import React from 'react';

import Box from 'components/elements/Box';
import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import { StyledEntityItemLoader } from 'components/data-containers/BrowseEntities/SkeletonLoader';

export const EntityItemsList = ({
  itemsAmount,
}: {
  itemsAmount: number;
}): JSX.Element => (
  <>
    {Array(itemsAmount)
      .fill(0)
      .map(
        (value: number, index: number): JSX.Element => (
          <StyledEntityItemLoader key={`entityItem-${index}`} />
        )
      )}
  </>
);

export const FollowingEntityItems = ({
  columnNumber,
  rowNumber,
}: {
  columnNumber: number;
  rowNumber: number;
}): JSX.Element => (
  <Box display="flex" justifyContent="space-around">
    {Array(columnNumber)
      .fill(0)
      .map((value: number, index: number) => (
        <Box key={`followingEntityItem-${index}`}>
          <EntityItemsList itemsAmount={rowNumber} />
        </Box>
      ))}
  </Box>
);

const SkeletonLoader: React.FC<{ title: string }> = ({ title }) => {
  return (
    <GenericComponent title={title} loading={false}>
      <AnimatedLoadingWrapper loading={true}>
        <Box display="flex" justifyContent="space-around">
          <EntityItemsList itemsAmount={3} />
        </Box>

        <FollowingEntityItems columnNumber={2} rowNumber={5} />
      </AnimatedLoadingWrapper>
    </GenericComponent>
  );
};

export default SkeletonLoader;
